var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "popReward-preload",
    style: {
      background: `
      url(${require('@images/rewardAnim/anim-1.png')}),
      url(${require('@images/rewardAnim/anim-2.png')}),
      url(${require('@images/rewardAnim/anim-bg-COIN.png')}),
      url(${require('@images/COIN.png')}),
      url(${require('@images/SPINS.png')}),
      url(${require('@images/LGCOIN.png')}),
      url(${require('@images/LGSPINS.png')}),
      url(${require('@images/GIFTSHARD.png')}),
      url(${require('@images/icon/icon-hic.png')}),
      url(${require('@images/icon/icon-pass.png')}),
      url(${require('@images/icon-stock.png')}),
      url(${require('@images/icon/icon-giftshare.png')}),
      `
    }
  }), _vm.taskInfo.popReward.icon === 'MORE' && _vm.show ? [_c('pop-prompt', {
    attrs: {
      "isClose": false,
      "show": _vm.show,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": true,
      "confirmText": "Go head"
    },
    on: {
      "update:show": function ($event) {
        _vm.show = $event;
      },
      "confirm": _vm.onMoreAccept
    }
  }, [_c('div', {
    staticClass: "pop-gamereward"
  }, [_c('div', {
    staticClass: "pop-gamereward__icon",
    style: {
      background: `url(${require('@images/upgrade-box.png')}) center/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-gamereward__title"
  }, [_vm._v("Congratulations")]), _vm.taskInfo.popReward.reward ? _c('div', {
    staticClass: "pop-gamereward-list"
  }, _vm._l(_vm.taskInfo.popReward.reward, function (value, key, index) {
    return _c('div', {
      staticClass: "pop-gamereward-item",
      class: [key == 'giftshard' && 'giftshard', !value && 'empty']
    }, [key !== 'giftshard' ? [key == 'coin' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-hic.png`),
        "alt": ""
      }
    }) : key == 'ticket' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-pass.png`),
        "alt": ""
      }
    }) : key == 'giftshard' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-giftshare.png`),
        "alt": ""
      }
    }) : key == 'usdt' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-usdt.png`),
        "alt": ""
      }
    }) : key == 'stock' ? _c('img', {
      attrs: {
        "src": require(`@images/icon-stock.png`),
        "alt": ""
      }
    }) : _vm._e(), _c('div', {
      staticClass: "pop-gamereward-item__label"
    }, [_vm._v(" +"), key == 'usdt' ? _c('m-count-up', {
      attrs: {
        "endVal": Number(value),
        "options": {
          decimalPlaces: 3
        }
      }
    }) : _c('m-count-up', {
      attrs: {
        "endVal": Number(value)
      }
    })], 1)] : value ? [_c('div', {
      staticClass: "pop-gamereward-item-giftshard"
    }, [_c('div', {
      staticClass: "pop-gamereward-item__title"
    }, [_vm._v("Shard Rewards(+"), _c('m-count-up', {
      attrs: {
        "endVal": Number(Object.values(value).reduce((sum, item) => sum + Number(item.amount || 0), 0))
      }
    }), _vm._v(")")], 1), _c('transition-group', {
      staticClass: "pop-gamereward-item-scroll",
      attrs: {
        "appear": "",
        "tag": "div"
      },
      on: {
        "before-enter": _vm.beforeEnter,
        "enter": _vm.enterGameGiftShard
      }
    }, _vm._l(value, function (val, ke, index) {
      return _c('div', {
        key: `gamereward${index}`,
        staticClass: "pop-gamereward-item-chip",
        attrs: {
          "data-index": index <= 50 ? index + 0.2 : 0
        }
      }, [_c('div', {
        staticClass: "pop-gamereward-item-chip-icon",
        style: {
          background: `url(${val.image}) center top/auto 100% no-repeat`
        }
      }), _c('div', {
        staticClass: "pop-gamereward-item__name"
      }, [_c('span', [_vm._v(_vm._s(val.name))])]), _c('div', {
        staticClass: "pop-gamereward-item__num"
      }, [_vm._v("+"), _c('m-count-up', {
        attrs: {
          "endVal": Number(val.amount)
        }
      })], 1)]);
    }), 0)], 1)] : _vm._e()], 2);
  }), 0) : _vm._e()])])] : _vm.taskInfo.popReward.multiple && _vm.show ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isRewardspinsAnim,
      expression: "isRewardspinsAnim"
    }]
  }, [_c('pop-prompt', {
    attrs: {
      "isClose": false,
      "title": " ",
      "confirmText": "Get",
      "content": "html",
      "show": _vm.show,
      "isBtnCancel": false
    },
    on: {
      "confirm": _vm.onAccept,
      "update:show": function ($event) {
        _vm.show = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-rewardspins"
  }, [_c('div', {
    staticClass: "pop-rewardspins__title"
  }, [_vm._v("Congratulations on getting")]), _c('div', {
    staticClass: "pop-multiple-reward__rewards",
    domProps: {
      "innerHTML": _vm._s(_vm.taskInfo.popReward.reward)
    }
  })])])], 1)] : _vm.taskInfo.popReward.icon === 'SPINS' && _vm.show ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isRewardspinsAnim,
      expression: "isRewardspinsAnim"
    }]
  }, [_c('pop-prompt', {
    attrs: {
      "isClose": false,
      "title": " ",
      "confirmText": "Get",
      "content": "html",
      "show": _vm.show,
      "isBtnCancel": false
    },
    on: {
      "confirm": _vm.onSpinAccept,
      "update:show": function ($event) {
        _vm.show = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-rewardspins"
  }, [_c('div', {
    staticClass: "pop-rewardspins__title"
  }, [_vm._v("Congratulations on getting")]), _c('div', {
    staticClass: "pop-rewardspins__reward spins"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.taskInfo.popReward.icon}.png`),
      "alt": ""
    }
  }), _vm._v("+" + _vm._s(_vm.fmt_pre(_vm.taskInfo.popReward.reward)))])])])], 1)] : _vm.taskInfo.popReward.icon === 'PASS' && _vm.show ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isRewardspinsAnim,
      expression: "isRewardspinsAnim"
    }]
  }, [_c('pop-prompt', {
    attrs: {
      "isClose": false,
      "title": " ",
      "confirmText": "Ok",
      "content": "html",
      "show": _vm.show,
      "isBtnCancel": false
    },
    on: {
      "confirm": _vm.onPassAccept,
      "update:show": function ($event) {
        _vm.show = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-rewardspins"
  }, [_c('div', {
    staticClass: "pop-rewardspins__title"
  }, [_vm._v("Congratulations on getting")]), _c('div', {
    staticClass: "pop-rewardspins__reward pass"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.taskInfo.popReward.icon}.png`),
      "alt": ""
    }
  }), _vm._v("+" + _vm._s(_vm.fmt_pre(_vm.taskInfo.popReward.reward)))]), _c('div', {
    staticClass: "pop-rewardspins__balance"
  }, [_vm._v(" Airdroppass: "), _c('img', {
    attrs: {
      "src": require(`@images/PASS.png`),
      "alt": ""
    }
  }), _c('span', [!_vm.isBalanceChange ? [_vm._v(" " + _vm._s(_vm.fmt_th(_vm.userInfo.airdrop_ticket)) + " ")] : _c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.userInfo.airdrop_ticket),
      "duration": 1
    }
  })], 2)])])])], 1)] : _vm.taskInfo.popReward.icon === 'USDT' && _vm.show ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isRewardspinsAnim,
      expression: "isRewardspinsAnim"
    }]
  }, [_c('pop-prompt', {
    attrs: {
      "isClose": false,
      "title": " ",
      "confirmText": "Ok",
      "content": "html",
      "show": _vm.show,
      "isBtnCancel": false
    },
    on: {
      "confirm": _vm.onUsdtAccept,
      "update:show": function ($event) {
        _vm.show = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-rewardspins"
  }, [_c('div', {
    staticClass: "pop-rewardspins__title"
  }, [_vm._v("Congratulations on getting")]), _c('div', {
    staticClass: "pop-rewardspins__reward usdt"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.taskInfo.popReward.icon}.png`),
      "alt": ""
    }
  }), _vm._v("+" + _vm._s(_vm.fmt_pre(_vm.taskInfo.popReward.reward)))]), _c('div', {
    staticClass: "pop-rewardspins__balance"
  }, [_vm._v(" Balance: "), _c('img', {
    attrs: {
      "src": require(`@images/USDT.png`),
      "alt": ""
    }
  }), _vm.balanceInfo ? _c('span', [!_vm.isBalanceChange ? [_vm._v(" " + _vm._s(_vm.fmt_th(_vm.balanceInfo.usdt.balance, 3, true, true)) + " ")] : _c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.balanceInfo.usdt.balance),
      "options": {
        decimalPlaces: 3
      },
      "duration": 1
    }
  })], 2) : _vm._e()])])])], 1)] : _vm.taskInfo.popReward.icon === 'CRY' && _vm.show ? [_c('pop-prompt', {
    attrs: {
      "isClose": false,
      "title": " ",
      "confirmText": "Accept",
      "content": "html",
      "show": _vm.show,
      "isBtnCancel": false
    },
    on: {
      "confirm": _vm.onFailAccept,
      "update:show": function ($event) {
        _vm.show = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-fail"
  }, [_c('div', {
    staticClass: "pop-fail__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/CRY.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-fail__title"
  }, [_vm._v("make persistent efforts")])])])] : _vm.taskInfo.popReward.icon !== 'MORE' && _vm.taskInfo.popReward.icon !== 'SPINS' && _vm.taskInfo.popReward.icon !== 'CRY' && _vm.show ? _c('div', {
    staticClass: "popCoinReward",
    class: [_vm.anim.step7 && 'step7', _vm.anim.step6 && 'step6', _vm.anim.step5 && 'step5', _vm.anim.step4 && 'step4', _vm.anim.step1 && 'step1', _vm.anim.step2 && 'step2', _vm.anim.step3 && 'step3', !_vm.taskInfo.popReward.isAnim && 'isDisableAnim']
  }, [[_c('div', {
    staticClass: "shadow"
  }), _c('div', {
    ref: "popRewardBodyRef",
    staticClass: "popReward-body"
  }, [_c('div', {
    staticClass: "popReward-xc",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "popReward-box__container",
    attrs: {
      "id": "container"
    }
  }), _c('div', {
    staticClass: "popReward-box"
  }, [_vm.anim.step3 ? [_c('img', {
    attrs: {
      "src": require(`@images/rewardAnim/anim-2.png`),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "popReward-box__coin",
    attrs: {
      "src": require(`@images/rewardAnim/anim-bg-COIN.png`),
      "alt": ""
    }
  })] : _vm._e(), !_vm.anim.step3 ? [_c('img', {
    attrs: {
      "src": require(`@images/rewardAnim/anim-1.png`),
      "alt": ""
    }
  })] : _vm._e(), _c('div', {
    staticClass: "popReward-box__coins"
  }, _vm._l(5, function (_) {
    return _c('span');
  }), 0), _vm.anim.stars.length > 0 ? _c('div', {
    staticClass: "popReward-box__explosion"
  }, _vm._l(_vm.anim.stars, function (star, index) {
    return _c('div', {
      key: index,
      staticClass: "star",
      style: star.style
    });
  }), 0) : _vm._e()], 2), _c('div', {
    staticClass: "popReward-main"
  }, [_c('div', {
    staticClass: "popReward-head"
  }), _c('div', {
    staticClass: "popReward-con"
  }, [_c('div', {
    staticClass: "popReward-info"
  }, [_c('div', {
    staticClass: "popReward-info__title"
  }, [_vm._v(_vm._s(_vm.$route.path == "/daily" ? "Login successful, I have received" : "Congratulations on getting"))]), _c('div', {
    staticClass: "popReward-info__reward"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require(`@images/icon/icon-hic.png`),
      "alt": ""
    }
  }), _vm._v(" +" + _vm._s(_vm.fmt_pre(_vm.taskInfo.popReward.reward)))])]), _vm.taskInfo.popReward.isAnim ? [_c('div', {
    staticClass: "popReward-btn",
    on: {
      "click": _vm.onAccept
    }
  }, [_vm._v("Get")]), _c('div', {
    staticClass: "popReward-info__balance"
  }, [_vm._v(" Balance: "), _c('img', {
    attrs: {
      "src": require(`@images/icon/icon-hic.png`),
      "alt": ""
    }
  }), _c('span', [_vm.anim.step6 ? [_vm._v(" " + _vm._s(_vm.fmt_th(_vm.userInfo.coin - _vm.taskInfo.popReward.reward)) + " ")] : _c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.userInfo.coin)
    }
  })], 2)])] : [_c('div', {
    staticClass: "popReward-btn",
    on: {
      "click": _vm.onAccept
    }
  }, [_vm._v("Ok")]), _c('div', {
    staticClass: "popReward-info__balance"
  })]], 2)])])])])]], 2) : _vm._e(), _c('m-coin-anim')], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };